import {
    AUTH_DATA,
    AUTH_DATA_SUCCESS,
    AUTH_DATA_FAILURE,
} from '../actions/action-types';

/**
 * initial state
 */
const INIT_STATE = {
    data: null,
    error: null,
    loading: true
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case AUTH_DATA:
            return { ...state, loading: true };

        case AUTH_DATA_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case AUTH_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default: return { ...state };
    }
}
